angular.module('Directives')
    .directive('inputWarningSync',

        function($compile, $timeout){
            return {
                restrict: 'C',
                require: '?ngModel',
                scope: {
                    ngModel: '@'
                },
                link: inputWarningSyncCtrl
            }

            function inputWarningSyncCtrl($scope, $element, $attrs, ngModel){
                var watch = $scope.$watch(function(){
                    return $element.val();
                }, function(newVal, oldVal){
                    ngModel.$setViewValue(newVal);
                    ngModel.$render();
                    if(newVal){
                        watch();
                    }
                });
            };
        }
    );


// WEBPACK FOOTER //
// ./js/directives/inputWarningSync.js